import httpService from "./httpService";

export const comboService = {
  getAll,
};

function getAll() {
  return httpService.get(`combos`);
}
